import superagent from 'superagent';
import getCookie from './getCookie';

export default async function uploadDocuments({ jsonBody }) {
  const webservice = 'https://admin.terramarbrands.mx:8083';
  let url = `${webservice}/uploadDocuments`;
  const location = process.env.REACT_APP_COUNTRY;

  let response = {};

  await superagent
    .post(url)
    .set(('Content-Type': 'application/json'))
    .auth(getCookie('TMBcartToken'), (location === 'MX' && {}) || { type: 'bearer' })
    .send(jsonBody)
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        ...jsonBody,
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
